var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.62,
    height: 31.61,
    viewBox: "0 0 35.62 31.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.26.73l.16.14L34.75,11.24a3,3,0,0,1,0,4.21l-13,13.17h9.11v3H7.89l-7-7.08a3,3,0,0,1,0-4.22L20.18.87A3,3,0,0,1,24.26.74Zm-18,18.36L3,22.42l6.16,6.2h6.68L6.3,19.09ZM22.3,3l-13.9,14L18.75,27.31,32.62,13.39,22.29,3Z",
    fill: "#624de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.cb10f711c0dfe1036b21ec67d699e88f.svg";
export { ForwardRef as ReactComponent };